/* Applications are saved to Klaviyo; Shopify customer tags alone grant access.
 * Never set membership/approval properties from this public form.
 */
(() => {
  function bindApplications(scope) {
    scope.querySelectorAll('[data-pc-application]').forEach((root) => {
      if (root.dataset.pcBound) return;
      root.dataset.pcBound = 'true';
      const form = root.querySelector('[data-pc-form]');
      const submit = root.querySelector('[data-pc-submit]');
      const error = root.querySelector('[data-pc-error]');
      const panel = root.querySelector('[data-pc-form-panel]');
      const confirmation = root.querySelector('[data-pc-confirmation]');
      const partnerInput = root.querySelector('[data-pc-partner-code]');
      const referrals = window.podiumReferrals;
      if (partnerInput && referrals) {
        partnerInput.value = referrals.current();
        partnerInput.addEventListener('input', () => partnerInput.setCustomValidity(''));
      }
      let busy = false;
      submit.disabled = false;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (partnerInput && referrals) {
          partnerInput.value = referrals.normalize(partnerInput.value);
          partnerInput.setCustomValidity(partnerInput.value && !referrals.valid(partnerInput.value)
            ? 'Please check the partner code, or leave it blank to apply.' : '');
        }
        if (busy || !form.reportValidity()) return;
        const fields = new FormData(form);
        const value = (name) => String(fields.get(name) || '').trim();
        // A basic spam trap only; direct requests can bypass client-side checks.
        if (value('company_website') || !value('first_name') || !value('email')) {
          error.hidden = false;
          return;
        }
        busy = true;
        error.hidden = true;
        submit.disabled = true;
        submit.textContent = 'Submitting…';
        form.setAttribute('aria-busy', 'true');
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 15000);
        try {
          const key = (root.dataset.klaviyoKey || '').trim();
          const list = (root.dataset.klaviyoList || '').trim();
          if (!key || !list) throw new Error('Application destination is missing.');
          const rides = fields.getAll('ride');
          const partnerCode = referrals ? referrals.normalize(value('partner_code')) : '';
          // Omit absent values so an ordinary repeat application cannot erase
          // an existing submitted code. This remains a mutable referral claim,
          // separate from the staff-confirmed Shopify customer attribution.
          const referralProperties = referrals && referrals.valid(partnerCode)
            ? { 'Submitted partner code': partnerCode } : {};
          const response = await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(key)}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', revision: '2026-07-15' },
            signal: controller.signal,
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Podium Club Waitlist',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: value('email'),
                        first_name: value('first_name'),
                        properties: {
                          Phone: value('phone'),
                          // Preserve the existing text property for old segments/exports.
                          'What they ride': rides.join(', '),
                          'Riding disciplines': rides,
                          'Current setup cost': value('spend'),
                          'Brands of interest': value('brands'),
                          ...referralProperties,
                        },
                      },
                    },
                  },
                },
                relationships: { list: { data: { type: 'list', id: list } } },
              },
            }),
          });
          if (response.status !== 202) throw new Error('Application was not accepted.');
          if (referrals) referrals.remember(partnerCode);
          panel.hidden = true;
          confirmation.hidden = false;
          root.querySelector('[data-pc-confirmation-heading]').focus();
        } catch {
          // Timeouts can be ambiguous. Never promise delivery we cannot confirm.
          error.hidden = false;
        } finally {
          clearTimeout(timeout);
          busy = false;
          submit.disabled = false;
          submit.textContent = 'Submit application';
          form.removeAttribute('aria-busy');
        }
      });
    });
  }
  bindApplications(document);
  if (!window.podiumApplicationEditorBound) {
    document.addEventListener('shopify:section:load', (event) => bindApplications(event.target));
    window.podiumApplicationEditorBound = true;
  }
})();
